
import React, { useState } from 'react'
import {
  Menu,
  Bell,
  Search,
  X
} from 'lucide-react'
import UserMenu from './UserMenu'
import MobileSearchOverlay from './MobileSearchOverlay'
import AdminUserSwitcher from './AdminUserSwitcher'
import AdminRolePicker from './AdminRolePicker'
import { SensitiveDataToggle } from './privacy/SensitiveDataToggle'
import { PrivacyOnboardingTooltip } from './privacy/PrivacyOnboardingTooltip'
import { User } from '../types/auth'
import { useRoleOverride } from '../contexts/RoleOverrideContext'
import { Z_INDEX } from '@/lib/constants/z-index'
import { usePageTitleStore } from '@/stores/page-title-store'



interface HeaderProps {
  onMobileMenuOpen: () => void
  user: User | null
  onLogout: () => void
}

export default function Header({ onMobileMenuOpen, user, onLogout }: HeaderProps) {
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false)
  const { effectiveRole, setRoleOverride, canOverrideRole } = useRoleOverride()
  const pageTitle = usePageTitleStore((s) => s.title)

  return (
    <>
      <header
        className="bg-transparent border-b border-gray-700/30 px-6 py-4 relative"
        style={{ zIndex: Z_INDEX.HEADER }}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center flex-1 gap-4">
            <button
              onClick={onMobileMenuOpen}
              className="lg:hidden btn-icon text-gray-400 hover:text-white"
            >
              <Menu size={20} strokeWidth={1.5} />
            </button>

            {/* Page Title */}
            {pageTitle && (
              <h1 className="font-display text-2xl text-white truncate flex items-center gap-2">
                <span className="text-brand-primary font-light">/</span>
                <span className="font-semibold">{pageTitle}</span>
              </h1>
            )}

            {/* Mobile Search Button */}
            <button
              onClick={() => setMobileSearchOpen(true)}
              className="md:hidden btn-icon text-gray-400 hover:text-brand-primary ml-auto"
            >
              <Search size={20} strokeWidth={1.5} />
            </button>
          </div>

          <div className="flex items-center space-x-3 sm:space-x-4">
            {/* Notifications */}
            {/* <button className="btn-icon text-gray-400 hover:text-brand-primary relative group">
              <Bell size={20} className="transition-transform duration-200 group-hover:rotate-12" />
              <span className="absolute -top-1 -right-1 h-3 w-3 bg-brand-red rounded-full flex items-center justify-center animate-pulse">
                <span className="text-xs text-white font-bold">3</span>
              </span>
            </button> */}

            {/* Sensitive Data Toggle */}
            <SensitiveDataToggle />

            {/* Admin Role Picker */}
            {canOverrideRole && (
              <AdminRolePicker
                currentRole={effectiveRole}
                onRoleChange={setRoleOverride}
              />
            )}

            {/* Admin User Switcher */}
            <AdminUserSwitcher />

            {/* User Menu */}
            <UserMenu user={user} onLogout={onLogout} />
          </div>
        </div>

        {/* Mobile Search Overlay */}
        <MobileSearchOverlay
          isOpen={mobileSearchOpen}
          onClose={() => setMobileSearchOpen(false)}
        />
      </header>

      {/* Privacy Feature Onboarding Tooltip */}
      <PrivacyOnboardingTooltip />
    </>
  )
}